import React from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'

const Img = ({ image, alt, className, objectFit, noLazy }) => {
  if (!image) return null
  return (
    <GatsbyImage
      image={image}
      alt={alt}
      className={className}
      objectFit={objectFit}
      loading={noLazy ? 'eager' : 'lazy'}
    />
  )
}

export default Img
